export const INVOICES_LIMIT = 20;
export const __FEATURE_LIMITS = 'LIMITS';
export const __FEATURE_BUNDLE_LIMITS_FA = 'LIMITS_FA';
export const __FEATURE_BUNDLE_LIMITS_AUTOBOOST = 'LIMITS_AUTOBOOST';
export const __FEATURE_AD_UPGRADE = 'FA';
export const __FEATURE_BTT = 'BTT';
export const __FEATURE_AUTO_BOOST = 'AUTOBOOST';
export const __FEATURE_ALL = 'ALL';
export const __FEATURE_TYPE_LIMITS_FA = 'limit_fa';
export const __FEATURE_TYPE_LIMITS_BOOST = 'limit_boost';
export const __FEATURE_TYPE_LIMITS_AUTOBOOST = 'limit_autoboost';
export const __FEATURE_TYPE_LIMIT = 'limit';
export const __FEATURE_TYPE_BOOST = 'boost';
export const __FEATURE_TYPE_BTT = 'btt';
export const __FEATURE_TYPE_AUTOBOOST = 'autoboost';
export const __FEATURE_TYPE_AUTOBOOST_AD = 'autoboost_ad';
export const __FEATURE_TYPE_PTT = 'ptt';
export const __FEATURE_TYPE_FREE = 'free';
export const __FEATURE_TYPE_UNLIMITED = 'unlimited';
export const __COUNTRY = 'COUNTRY';
export const __CITY = 'CITY';
export const __RADIX_DECIMAL = 10;
export const __ORIGIN_PACKAGE = 'package';
export const __ORIGIN_PAYMENT = 'payment';
export const __CART_PKG_QUANTITY_MAX = 5;
export const __CART_PKG_QUANTITY_MIN = 0;
export const __MONET_TRANSITION_PARAMS = 'monetTransParams';
export const __MONET_MULTI_CHECKOUT_PACKAGES = 'monetPkgSelected';
export const __SELECTED_PACKAGE = 'pkgSeleced';
export const __COUPON = 'coupon';
export const __FEATURE_TYPES_FROM_TRANSITION = ['limit', 'limit_fa', 'limit_boost', 'limit_autoboost', 'boost', 'ALL', 'btt', 'autoboost', 'autoboost_ad', 'ptt'];
export const __PRODUCT_TYPE_MAP = {
    BTT: 'btt',
    LIMITS: 'limit',
    FA: 'fa',
    AUTOBOOST: 'autoboost',
    LIMITS_FA: 'limit_fa',
    LIMITS_AUTOBOOST: 'limit_autoboost',
    btt: 'btt',
    boost: 'boost',
    ALL: 'ALL'
};
export const __TRACK_PRODUCT_TYPE_MAP = {
    LIMITS: 'limits',
    FA: 'upgrade_ad',
    LIMITS_FA: 'limit_fa',
    LIMITS_AUTOBOOST: 'limit_autoboost',
    ALL: 'all'
};
export const __FEATURE_TYPE_MAP = {
    limit: 'LIMITS',
    boost: 'FA',
    btt: 'FA'
};

export const HOW_IT_WORKS_FEATURES = ['FA', 'BTT', 'AUTOBOOST'];

export const __BUSINESS_USER = 'BUSINESS';
export const __ADDITIONAL_NON_EDIT_FIELDS = ['type', 'vatNumber'];
export const __GST_FIELD_NAME = 'vatNumber';
export const __BUSINESS_PACKAGES_ROUTE = '/payments/businesspackages/my_account';
export const __NOT_ENOUGHT_UNITS = 'not_enough_units';
export const __BUSINESS_PACKAGES_APPLICATION = 'business_package_application';
export const __DESIGN_TYPE = 'new';
